import { useNavigate } from 'react-router-dom';
import { Wind, BookOpen, Play } from 'lucide-react';
import { defaultMinutes, hasGuidedTimer, learnMoreUrl, patternText } from '@/lib/breathing';

export const GuidedBreathingList = ({ library }) => {
  const nav = useNavigate();
  const items = library.filter(hasGuidedTimer);
  if (!items.length) return null;
  return (
    <div data-testid="guided-breathing-list">
      <div className="flex items-center justify-between mb-2">
        <div className="label-mini flex items-center gap-1.5"><Wind className="w-3.5 h-3.5 text-[#7DD3FC]" /> Guided Breathing</div>
        <div className="text-[11px] text-muted-foreground">Optional · any time · no score impact</div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {items.map(a => (
          <div key={a.id} className="regen-card-elevated overflow-hidden flex" data-testid={`breathing-card-${a.id}`}>
            <div className="w-20 flex-shrink-0 bg-[var(--c-film)]">{a.image_url && <img src={a.image_url} alt={a.name} className="w-full h-full object-cover" />}</div>
            <div className="flex-1 min-w-0 p-3">
              <div className="font-display font-bold text-sm truncate">{a.name}</div>
              <div className="text-[11px] text-muted-foreground font-mono truncate">{patternText(a.breathing.phases)}</div>
              <div className="text-[11px] text-muted-foreground">{defaultMinutes(a)} min</div>
              <div className="flex gap-2 mt-2">
                <button onClick={() => nav(`/app/breathing/${a.id}`)} data-testid={`breathing-start-${a.id}`}
                  className="h-8 px-3 rounded-full bg-[#7DD3FC] text-[#081726] text-xs font-semibold inline-flex items-center gap-1"><Play className="w-3.5 h-3.5" /> Start</button>
                {a.breathing.academy_article_id && (
                  <button onClick={() => nav(learnMoreUrl(a), { state: { from: 'recovery' } })} data-testid={`breathing-learn-${a.id}`}
                    className="h-8 px-3 rounded-full bg-[var(--c-film)] text-xs font-semibold inline-flex items-center gap-1"><BookOpen className="w-3.5 h-3.5" /> Learn More</button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
